
interface HeroProps {
  scrollToContact: () => void;
}

export default function Hero({ scrollToContact }: HeroProps) {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center pt-20"
      style={{
        backgroundImage: 'url(https://readdy.ai/api/search-image?query=Serene%20misty%20mountain%20forest%20landscape%20with%20tall%20evergreen%20trees%20in%20soft%20morning%20light%2C%20peaceful%20natural%20scenery%20with%20layers%20of%20green%20mountains%20fading%20into%20distance%2C%20minimalist%20nature%20photography%20style%2C%20clean%20and%20fresh%20atmosphere%2C%20professional%20corporate%20background%20with%20natural%20elements&width=1920&height=1080&seq=hero-forest-001&orientation=landscape)',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-emerald-900/80 to-emerald-700/60"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          内装工事の<br />トータルサポート
        </h1>
        <p className="text-xl md:text-2xl text-white/95 mb-8 max-w-3xl mx-auto leading-relaxed">
          設計から施工まで、お客様の理想空間を実現します。<br />
          丁寧な提案と確かな技術で、安心してご相談いただける内装工事サービスを提供いたします。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button 
            onClick={scrollToContact}
            className="bg-white text-emerald-800 px-8 py-4 rounded-full text-lg font-semibold hover:bg-emerald-50 transition-all shadow-lg cursor-pointer whitespace-nowrap"
          >
            無料相談を申し込む
          </button>
          <button className="border-2 border-white text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap">
            サービス詳細
          </button>
        </div>
      </div>
    </section>
  );
}
